// data
export const SET_DATASETS = "SET_DATASETS";
export const SET_SELECTED_DATASET = "SET_SELECTED_DATASET";
export const SET_CHECKED = "SET_CHECKED";
